import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const packagesReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.PACKAGE_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.PACKAGE_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.PACKAGE_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PACKAGES_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PACKAGES_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PACKAGES_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PACKAGE_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PACKAGE_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PACKAGE_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const packageReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.PACKAGE_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.PACKAGE_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.PACKAGE_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { packagesReducer, packageReducer };
